import { render, staticRenderFns } from "./BodyDonnees.vue?vue&type=template&id=70d6bb72&scoped=true"
import script from "./BodyDonnees.vue?vue&type=script&lang=js"
export * from "./BodyDonnees.vue?vue&type=script&lang=js"
import style0 from "./BodyDonnees.vue?vue&type=style&index=0&id=70d6bb72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d6bb72",
  null
  
)

export default component.exports